import { Matcher } from '@flakiness/server/common/fql/matcher.js';
import { Query } from '@flakiness/server/common/fql/query.js';
import { consume, ContextType } from '@lit/context';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { contexts } from '../contexts.js';
import { hrefOrClick } from '../linkifier.js';
import { linkStyles } from './cssstyles.js';
import { highlight } from './hl-span.js';

@customElement('test-tag')
class TestTag extends LitElement {
  @property({ attribute: false }) tag?: string;
  @property({ attribute: false }) fql?: Query;
  @consume({ context: contexts.linkFQL, subscribe: true }) private _fqlLinkifier?: ContextType<typeof contexts.linkFQL>;

  render() {
    if (!this.tag)
      return nothing;
    const hl = this.fql?.highlightTag(this.tag);
    const link = this.tag && this.fql ? this._fqlLinkifier?.(this.fql.toggleFilter(Matcher.TAG_CONTAINS.create([this.tag])).serialize()) : undefined;
    return html`
      <sl-tooltip hoist>
        <div slot=content>
          #${highlight(this.tag, hl)}
        </div>
        <a ${hrefOrClick(link)} class=body><span class=hash ?is-matching=${hl && hl.length > 0}>#</span>${highlight(this.tag, hl)}</a>
      </sl-tooltip>
    `
  }

  static styles = [linkStyles, css`
    :host {
      min-width: 2em;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .body {
      background: var(--sl-color-neutral-100);
      padding: var(--sl-spacing-2x-small);
      border-radius: var(--sl-border-radius-medium);
      color: var(--sl-color-neutral-600) !important;
    }

    a {
      cursor: pointer;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    [is-matching] {
      background-color: var(--fk-color-highlight);
    }


  `];
}
